
import { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'

//Components
import { Grid, Icon, Divider } from "@mui/material";

import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Form,
    Select,
    Table
} from "@gpstrackit/react-controls";
import CustomCard from 'Components/Card';
import { copyToClipboard } from 'Core/data/Helpers';

//Notification
import { NotificationManager } from "Components/Notifications";

//Actions
import {
    changeScriptGetDeviceRequest,
    changeScriptRequest,
    changeScriptGetScritps,
    clearRedux,
} from 'Redux/actions';

//Styles
import './changeScript.scss';

const TableDevices = (props) => {
    const { idTable, itemPuls, pulsCustomers, setPulsCustomers, tableRefs, messages } = props
    const tableRef = useRef(null);
    tableRefs.current[idTable] = tableRef;

    return (
        <Table
            ref={tableRef}
            name={`devices_${idTable}`}
            columns={[
                {
                    key: "icon",
                    title: "",
                    width: 50,
                    show: true,
                    sort: false,
                    locked: false,
                    resize: false,
                    render: (item) => {
                        let ready = false;
                        if (item?.newScriptVersion && item?.unitConfig?.scriptVersion) {
                            ready = true;
                        }
                        if (item?.newScriptId && item?.newScriptName) {
                            ready = true;
                        }
                        return (
                            <span>{
                                ready ?

                                    <Icon className="toolbar-list-icon fg-green">
                                        check_circle
                                    </Icon>
                                    :
                                    <Icon className="toolbar-list-icon fg-red">
                                        warning
                                    </Icon>
                            }</span>
                        )
                    }
                },
                {
                    key: "imei",
                    field: "imei",
                    title: messages['change_script_imei'],
                    width: 150,
                    show: true,
                    sort: false,
                    locked: false,
                    resize: false,
                    render: (item) => {
                        return <span>{item?.imei}</span>
                    }
                },
                {
                    key: "deviceModel",
                    field: "deviceModel",
                    title: messages['change_script_model'],
                    width: 150,
                    show: true,
                    sort: false,
                    locked: false,
                    resize: false,
                    render: (item) => {
                        return <span>{item?.deviceModel?.name}</span>
                    }
                },
                {
                    key: "pre_load_script",
                    title: messages['change_script_pre_loaded_script'],
                    width: 150,
                    show: true,
                    sort: false,
                    locked: false,
                    resize: false,
                    render: (item) => {
                        let label = "-----------------";
                        if (item?.unitConfig?.scriptVersion) {
                            label = `${item?.unitConfig?.scriptVersion}.${item?.unitConfig?.configVersion}`
                        }
                        if (item?.unitConfig?.calampApi === "CTC" && item?.unitConfig?.configVersion) {
                            label = `${item?.unitConfig?.configVersion}`
                        }
                        return (
                            <span>{label}</span>
                        )
                    }
                },
                {
                    key: "assigned_script",
                    title: messages['change_script_assigned_script'],
                    width: 200,
                    show: true,
                    sort: false,
                    locked: false,
                    resize: false,
                    render: (item) => {
                        let label = "-----------------";
                        if (item?.newScriptVersion) {
                            label = `${item?.newScriptVersion}.${item?.newConfigVersion}`
                        }
                        if (item?.newScriptName) {
                            label = item?.newScriptName
                        }
                        return (
                            <span>{label}</span>
                        )
                    }
                }
            ]}
            data={itemPuls?.devices || []}
            height="auto"
            onSelectedItems={(items) => {
                let plsCustomers = pulsCustomers;
                plsCustomers[idTable].selectedItems = items;
                setPulsCustomers([...plsCustomers]);
            }}
            hidePagination
            onChangeColumns={() => { }}
        />
    )
}

const changeScript = (props) => {
    const formRef = useRef(null);

    const { messages } = useIntl();
    const { tableRef, single, getDevice } = props;
    const tableRefs = useRef([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    //Redux States
    const { device, loading, openModal, result, searchDevices } = useSelector(state => state.changeScriptRedux)
    const { scripts } = useSelector(state => state.generalRedux);

    //Local States
    const [serial, setSerial] = useState("");
    const [step, setStep] = useState(1);
    const [scriptsList, setScripts] = useState([]);
    const [script, setScript] = useState(null);
    const [pulsCustomers, setPulsCustomers] = useState([]);
    const [devices, setDevices] = useState([]);

    const searchDevice = () => {
        let deviceSearchCriteriaArr = serial.split(/[\s,;\t\n]+/);
        if (deviceSearchCriteriaArr.length > 1) {
            let criterias = [];

            deviceSearchCriteriaArr.forEach(criteria => {
                let escCriteria = criteria.trim();
                let regx = /[^a-zA-Z0-9]/g;
                escCriteria = escCriteria.replace(regx, '');

                if (devices && devices.length) {
                    for (let index in devices) {
                        let device = devices[index];

                        if (device.imei != escCriteria && device.esn != escCriteria) {
                            criterias.push(escCriteria);
                        }
                    }
                } else {
                    criterias.push(escCriteria);
                }
            });

            if (criterias.length) {
                dispatch(changeScriptGetDeviceRequest(criterias));
            }

        } else {
            let isValid = true;
            for (let index in devices) {
                let device = devices[index];
                if (device.esn.toString() === serial) {
                    isValid = false;
                    break;
                }
            }
            if (isValid) {
                dispatch(changeScriptGetDeviceRequest(serial));
            } else {
                NotificationManager.warning(
                    messages['change_script_device_is_already_added'],
                    messages['change_script_title'],
                    3000
                );
            }
        }
    }

    const closeModal = () => {
        setSerial("");
        setStep(1);
        setScripts([]);
        setScript(null);
        setDevices([]);
        dispatch(clearRedux("CHANGE_SCRIPT"));
    }

    const applyChanges = () => {
        let payload = [];
        pulsCustomers.map((item, index) => {
            item.devices.map((dev, indx) => {
                if (dev.unitConfig.calampApi === "PULS") {
                    payload.push({
                        calampApi: dev?.unitConfig.calampApi,
                        pulsCustomerId: dev?.unitConfig.pulsCustomerId,
                        esn: dev.esn,
                        scriptVersion: dev.newScriptVersion ? dev.newScriptVersion : dev.unitConfig.scriptVersion,
                        configVersion: dev.newConfigVersion ? dev.newConfigVersion : dev.unitConfig.configVersion
                    })
                } else if (dev.unitConfig.calampApi === "CTC") {
                    payload.push({
                        calampApi: dev?.unitConfig.calampApi,
                        esn: dev.esn,
                        scriptId: dev.newScriptId ? dev.newScriptId : dev.unitConfig.scriptVersion,
                        scriptVersion: 'ctc'
                    })
                }
            })
        })

        let incompleDevice = payload.some(x => !x.scriptVersion)

        if (!incompleDevice)
            dispatch(changeScriptRequest(payload))
        else {
            NotificationManager.warning(
                messages['change_script_no_script_devices'],
                messages['change_script_title'],
                3000
            );
        }


    }

    function loadPulsCustomersIds(currentDevices) {
        let dvcs = devices;
        if (currentDevices)
            dvcs = currentDevices

        let pulsCustomers = [];

        dvcs.map((item, index) => {
            if (item?.unitConfig?.calampApi !== "CTC") {
                let pulsCustomerIndex = pulsCustomers.findIndex(x => x.pulsCustomerId === item?.unitConfig?.pulsCustomerId);
                if (pulsCustomerIndex === -1) {
                    let pulsCustomer = {
                        pulsCustomerId: item?.unitConfig?.pulsCustomerId,
                        calampApi: item?.unitConfig?.calampApi,
                        devices: [item],
                        selectedItems: []
                    }
                    pulsCustomers.push(pulsCustomer);
                } else pulsCustomers[pulsCustomerIndex].devices.push(item);
            } else {
                let pulsCustomerIndex = pulsCustomers.findIndex(x => x.accountId === item?.unitConfig?.accountId);
                if (pulsCustomerIndex === -1) {
                    let pulsCustomer = {
                        calampApi: item?.unitConfig?.calampApi,
                        accountId: item?.unitConfig?.accountId,
                        devices: [item],
                        selectedItems: []
                    }
                    pulsCustomers.push(pulsCustomer);
                } else pulsCustomers[pulsCustomerIndex].devices.push(item);
            }
        });

        setPulsCustomers(pulsCustomers);
        //load scripts for every puls customer
        dispatch(changeScriptGetScritps(pulsCustomers))
    }

    useEffect(() => {
        if (searchDevices) {
            dispatch(clearRedux("CHANGE_SCRIPT", { searchDevices: null }))

            if (!searchDevices?.total || searchDevices?.total === 0) {
                NotificationManager.warning(
                    messages['change_script_device_has_not_been_found'],
                    messages['change_script_title'],
                    3000
                );
            } else {
                let currentDevices = searchDevices.items;

                let noCalampDevices = currentDevices.filter(x => x.deviceModel?.manufacturer?.name !== "CalAmp")
                let calampDevices = currentDevices.filter(x => x.deviceModel?.manufacturer?.name === "CalAmp");
                if (noCalampDevices?.length > 0) {
                    setSerial("");
                    NotificationManager.warning(
                        messages['devices_main_calamp_error'],
                        messages['change_script_title'],
                        3000
                    );
                }

                if (calampDevices?.length > 0) {
                    setSerial("");
                    setDevices([...devices, ...calampDevices])
                    if (single) {
                        loadPulsCustomersIds(calampDevices);
                    }
                }
            }
        }
        if (result?.updateScript) {
            let transactionId = result.result.transactionId;
            let message = messages["change_script_transaction_request_message"]
            NotificationManager.success(message, messages['devices_import_title'], 10000, () => {
                copyToClipboard(transactionId, messages['common_copied']);
                navigate(`/app/transactions/list/${transactionId}`);

            }, null, '', null);

            closeModal();
            getDevice && getDevice();
            tableRef && tableRef?.current?.getData();
        } else if (result && !result?.updateScript) {
            NotificationManager.error(
                messages['change_script_error_message'],
                messages['change_script_title'],
                3000
            );
            dispatch(clearRedux("CHANGE_SCRIPT", { result: null }))
        }

    }, [result, searchDevices])

    useEffect(() => {
        if (openModal && scripts) {
            if (scripts && scripts.length > 0) {
                let current = scripts.map((item) => ({ label: `${item}`, id: `${item}` }));
                setScripts(current);
            }
        }
    }, [scripts])


    let validateStepOne = step === 1 && !single
    let validateStepTwo = step === 2 || single

    let ctcDevicesList = pulsCustomers?.length ? pulsCustomers?.filter((dc) => dc?.calampApi === "CTC") : []
    let pulsDevicesList = pulsCustomers?.length ? pulsCustomers?.filter((dc) => dc?.calampApi !== "CTC") : []

    let ctcValidation = false
    let pulsValidation = false

    ctcDevicesList?.length && ctcDevicesList?.map((dc) => {
        let ctcVal = dc?.devices?.some((device) => (!device?.newScriptId && !device?.newScriptName))
        if (ctcVal) ctcValidation = true
    })

    pulsDevicesList?.length && pulsDevicesList?.map((dc) => {
        let pulsVal = dc?.devices?.some((device) => (!device?.newConfigVersion && !device?.newScriptVersion))
        if (pulsVal) pulsValidation = true
    })

    return (
        <Modal
            open={openModal}
            title={messages['change_script_title']}
            position="right"
            size="medium"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                {
                    validateStepOne &&
                    <div style={{ padding: '0 10px', height: '77vh' }}>
                        <Grid
                            container
                            spacing={1}
                        >
                            <Grid item xs={8}>
                                <Form
                                    ref={formRef}
                                    onValidSubmit={() => searchDevice()}
                                >
                                    <Input
                                        label={messages['change_script_input']}
                                        placeholder={messages['change_script_input']}
                                        value={serial}
                                        required
                                        requiredMessage={messages['required_field']}
                                        onChange={(value) => setSerial(value)}
                                    />
                                </Form>
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ marginTop: 26 }}>
                                    <Button
                                        className="btn-dark-blue"
                                        onClick={() => formRef?.current?.submit()}
                                    >
                                        {messages['common_add']}
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                        {devices.length > 0 ? devices.map((item, index) => {
                            return (
                                <CustomCard
                                    key={index}
                                    onClick={() => {
                                        let currentDevices = devices;
                                        let selected = currentDevices.findIndex((device) => device.esn === item.esn);
                                        if (selected > -1) {
                                            currentDevices.splice(selected, 1);
                                        }
                                        setDevices([...currentDevices]);
                                    }}
                                >
                                    <div style={{ display: 'grid' }}>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['change_script_imei']}</label><span>{item.imei}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['change_script_serial']}</label><span>{item.esn}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['change_script_model']}</label><span>{item?.deviceModel?.name}</span>
                                        </div>
                                    </div>
                                </CustomCard>
                            )
                        }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['common_no_devices_added']}</span></div>}
                    </div>
                }
                {
                    validateStepTwo &&
                    <div style={{ padding: '0 10px', height: '77vh' }}>
                        {
                            pulsCustomers && pulsCustomers.length > 0 &&
                            pulsCustomers.map((itemPuls, index) => {
                                return (
                                    <Grid container key={index}>
                                        <Grid item xs={12}>
                                            <label style={{ fontWeight: 700, marginRight: 5, marginTop: 15 }}>{itemPuls.pulsCustomerId}</label>
                                        </Grid>
                                        <div style={{ width: '100%', marginBottom: 10, marginTop: 5 }}>
                                            <Divider style={{ backgroundColor: '#999999' }} />
                                        </div>
                                        <Grid item xs={9}>
                                            {
                                                itemPuls?.calampApi === "PULS" ?
                                                    <Select
                                                        id={`list-pulscustomer-puls-scripts${index}`}
                                                        value={itemPuls.script}
                                                        options={itemPuls.scripts || []}
                                                        label={messages['change_script_script']}
                                                        placeholder={messages['change_script_script']}
                                                        onChange={(item) => {
                                                            let plsCustomers = pulsCustomers;
                                                            plsCustomers[index].script = item;
                                                            setPulsCustomers([...plsCustomers]);
                                                        }}
                                                        valueField="name"
                                                        textField="name"
                                                        getOptionLabel={e => `${e.scriptVersion}.${e.configVersion} - ${e.name}`}
                                                        getOptionValue={e => e.name}
                                                        required
                                                        requiredMessage={messages['required_field']}
                                                    />
                                                    :
                                                    <Select
                                                        id={`list-pulscustomer-ctc-scripts${index}`}
                                                        value={itemPuls.script}
                                                        options={itemPuls.scripts || []}
                                                        label={messages['change_script_script']}
                                                        placeholder={messages['change_script_script']}
                                                        onChange={(item) => {
                                                            let plsCustomers = pulsCustomers;
                                                            plsCustomers[index].script = item;
                                                            setPulsCustomers([...plsCustomers]);
                                                        }}
                                                        valueField="name"
                                                        textField="name"
                                                        getOptionLabel={e => `${e.name}`}
                                                        getOptionValue={e => e.name}
                                                        required
                                                        requiredMessage={messages['required_field']}
                                                    />
                                            }
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Button style={{ marginLeft: 5, marginTop: 25 }}
                                                className="btn-dark-blue"
                                                onClick={() => {
                                                    let plsCustomers = pulsCustomers;
                                                    if (!itemPuls.selectedItems.length) {
                                                        NotificationManager.warning(
                                                            messages['change_script_no_devices_selected'],
                                                            messages['change_script_title'],
                                                            3000
                                                        );
                                                        return
                                                    }
                                                    if (!itemPuls?.script) {
                                                        NotificationManager.warning(
                                                            messages['change_script_no_scripts_selected'],
                                                            messages['change_script_title'],
                                                            3000
                                                        );
                                                        return
                                                    }
                                                    if (itemPuls.selectedItems.length > 0 && itemPuls.script) {
                                                        itemPuls.selectedItems.map((item, i) => {
                                                            let devIndex = plsCustomers[index].devices.findIndex(x => x.esn === item.esn);
                                                            let dev = JSON.parse(JSON.stringify(itemPuls.devices[devIndex]))

                                                            if (item?.unitConfig?.calampApi === "PULS") {
                                                                dev.newScriptVersion = itemPuls.script.scriptVersion;
                                                                dev.newConfigVersion = itemPuls.script.configVersion;
                                                                plsCustomers[index].devices[devIndex] = dev;
                                                            }
                                                            if (item?.unitConfig?.calampApi === "CTC") {
                                                                dev.newScriptId = itemPuls.script.id;
                                                                dev.newScriptName = itemPuls.script.name;
                                                                plsCustomers[index].devices[devIndex] = dev;
                                                            }
                                                            plsCustomers[index].selectedItems = [];
                                                            tableRefs?.current[index]?.current?.setSelectedItems([])
                                                        });
                                                        setPulsCustomers([...plsCustomers]);
                                                    }
                                                }}
                                            >
                                                {messages['change_script_assign']}
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TableDevices
                                                idTable={index}
                                                itemPuls={itemPuls}
                                                pulsCustomers={pulsCustomers}
                                                setPulsCustomers={setPulsCustomers}
                                                tableRefs={tableRefs}
                                                messages={messages}
                                            />
                                        </Grid>
                                    </Grid>
                                )
                            })
                        }
                    </div>
                }
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                {step === 2 && !single &&
                    <Button
                        className="btn btn-cancel btn-gray"
                        onClick={() => setStep(1)}
                    >
                        {messages['common_back']}
                    </Button>
                }
                <Button
                    disabled={(step === 1 && devices.length === 0 || ((step === 1 && ctcValidation) || (step === 1 && pulsValidation))) || (step === 2 && ctcValidation) || (step === 2 && pulsValidation)}
                    className="btn-dark-blue"
                    onClick={() => {
                        if (single) {
                            applyChanges();
                        } else {
                            if (step < 2) {
                                setStep(step + 1);
                                if (step + 1 === 2) {
                                    loadPulsCustomersIds();
                                }
                            } else {
                                applyChanges();
                            }
                        }
                    }}
                >
                    {step === 1 && !single ? messages['common_next'] : messages['change_script_change']}
                </Button>
            </ModalFooter>
        </Modal >
    )
}

export default changeScript;